import React, { useState } from "react";
import * as Icon from "react-feather";
import "./App.scss";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Home from "./pages/Home";
import Notfound from "./pages/Notfound";
import Photography from "./pages/Photography";
import Resumes from "./pages/Resumes";
import { createBrowserRouter, RouterProvider, Outlet } from "react-router-dom";
import usePageTracking from "./hooks/usePageTracking";

// Layout component that runs tracking inside router context
function Layout({ lightMode }) {
  usePageTracking(); // <-- this fires on every route change
  return <Outlet context={{ lightMode }} />;
}

function App() {
  const [lightMode, setLightMode] = useState(false);

  // Sync body class with lightMode
  lightMode
    ? document.body.classList.add("light")
    : document.body.classList.remove("light");

  const handleMode = () => {
    setLightMode((prev) => !prev);
    document.body.classList.toggle("light");
  };

  // Router setup
  const router = createBrowserRouter([
    {
      element: <Layout lightMode={lightMode} />,
      children: [
        { path: "/", element: <Home lightMode={lightMode} /> },
        { path: "/about", element: <About /> },
        { path: "/resume", element: <Resumes /> },
        { path: "/photography", element: <Photography /> },
        { path: "/contact", element: <Contact /> },
        { path: "*", element: <Notfound /> },
      ],
    },
  ]);

  return (
    <>
      <div className="light-mode">
        <span className="icon">
          <Icon.Sun />
        </span>
        <button
          className={
            lightMode ? "light-mode-switch active" : "light-mode-switch"
          }
          onClick={handleMode}
        ></button>
      </div>
      <RouterProvider router={router} />
    </>
  );
}

export default App;
